<script setup lang="ts">
import Wrapper from '../ui/wrapper/Wrapper.vue';
import EventsContent from '../ui/events/EventsContent.vue';
import { Header } from '~/widgets/header/';
import { Footer } from '~/widgets/footer/';
import { CookieBanner } from '~/widgets/cookie-banner';

onErrorCaptured((error, instance, info) => {
  console.error('Error captured:', error);
  console.error('Component instance:', instance);
  console.error('Error info:', info);
});
</script>

<template>
  <Wrapper>
    <Header />
    <BannerSiteTop />
    <EventsContent>
      <slot />
    </EventsContent>
    <Footer />
    <CookieBanner />
  </Wrapper>
</template>
